import { WEBBACK_V2_API } from "@constants"

const SKU_THUMBNAILS_URL = 'https://assets.dataseekers.com/retail-sku-thumbnails'

export default function useBuildExternalURL({ imageData, siteData }) {
    return {
        imageURL: buildImageURL(imageData),
        productURL: buildProductURL(siteData)
    }
}

function buildImageURL(imageData) {
    if (!imageData) return '/images/defaultImage.png'

    const { siteID, productID, date, skuID } = imageData

    if (skuID) {
        return `${SKU_THUMBNAILS_URL}/${skuID}.png`
    }

    return '/images/defaultImage.png'
}

function buildProductURL(siteData) {
    if (!siteData) return ''
    const { siteID, productID, asin } = siteData
    const id = asin || productID || 0
    return `${WEBBACK_V2_API}/sku-details/product-url/${siteID}/${id}`
}
